module.exports = __webpack_public_path__ + "img/52.c8a59eeb.jpg";